import React, { useState, useEffect } from 'react';
import { DropdownToggle, DropdownMenu, DropdownItem, UncontrolledDropdown, UncontrolledTooltip, Card } from 'reactstrap';
import {Link, useNavigate} from 'react-router-dom';
import { default as Badges } from './Badges';
import { default as PlayerInfo } from './PlayerInfo';
import profilebanner from '../../img/profilelogo.png';
import profilebanner2 from '../../img/profilelogo2.png';
import profilebanner3 from '../../img/profilelogo3.png';
import profilebanner4 from '../../img/profilelogo4.png';
import { getTrackerToken } from '../../utils/GetToken.js';
import Loading from '../Loading.js';
import ArrowIcon from '../SVG/ArrowIcon.js';
import ServerBlock from "../Home/ServerBlock";

export default function Player(props) {

    const [loading, setLoading] = useState(true);
    const [isValid, setValid] = useState(true);
    const [playerData, setPlayerData] = useState([]);
    const [sessionData, setSessionData] = useState([]);
    const [nameHistory, setNameHistory] = useState([]);
    const [bannerId, setBannerId] = useState(4);
    const [bannerStyle, setBannerStyle] = useState({paddingTop: '4rem', background: `url(${profilebanner4}) no-repeat center -20px`}); 
    const name = props.name;
    const navigate = useNavigate();

    useEffect(() => {
        switch (bannerId) {
            case 1:
                setBannerStyle({paddingTop: '4rem', background: `url(${profilebanner}) no-repeat center -20px`});
                break;
            case 2:
                setBannerStyle({paddingTop: '4rem', background: `url(${profilebanner2}) no-repeat center -20px`});
                break;
            case 3:
                setBannerStyle({paddingTop: '4rem', background: `url(${profilebanner3}) no-repeat center -20px`});
                break;
            case 4:
                setBannerStyle({paddingTop: '4rem', background: `url(${profilebanner4}) no-repeat center -20px`});
                break;
            default:
                setBannerStyle({paddingTop: '4rem', background: `url(${profilebanner4}) no-repeat center -20px`});
                break;
        }
    }, [bannerId])

    useEffect(() => {
        async function fetchData() {
            try {
                setLoading(true);
                
                const statsData = await fetch(`api/players/${encodeURIComponent(name)}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${getTrackerToken()}`
                    }
                }).then(r => r.json());

                setPlayerData(statsData);
                setSessionData(statsData.sessions);
                
                if (statsData.nameHistory) {
                    let reverseNameHistory = statsData.nameHistory.slice().reverse();
                    setNameHistory([...new Set(reverseNameHistory.slice(0, 10))]);
                }
                else {
                    setNameHistory([]);
                }
                
                setValid(true);
            }
            catch {
                setValid(false);
            }

            setLoading(false);
        }
        setBannerId(Math.round(Math.random() * 3) + 1);
        fetchData();
    }, [name]);

    const goBack = () => {
        navigate(-1);
    };


    let contents = loading ? <Loading message={`Loading data for ${name}`}/> : <PlayerInfo isValid={isValid} playerData={playerData} mapData={playerData.mapStats} sessionData={sessionData} />;
    return (
        <>
        <div style={bannerStyle}>
            <Badges isValid={isValid} playerData={playerData} />
            <div style={{ display: 'flex', alignItems: 'center'}}>
                <a className="backbtn" onClick={goBack}>
                    <ArrowIcon />
                </a>
                {playerData.onlineServer ?
                    <>
                        <Link to={`/server/${playerData.onlineServer.address}`}>
                            <span id="status" className="online-circle" style={{marginTop: '0.45rem' }}/>
                        </Link>
                        <UncontrolledTooltip placement="bottom" target="status" style={{backgroundColor: 'transparent', boxShadow: 'none', maxWidth: '32em', width: '32em', textAlign: 'left'}}>
                            <ServerBlock key='online' server={playerData.onlineServer} index='online' playerName={playerData.name} />
                        </UncontrolledTooltip>
                    </>
                : null}
                <h1 style={{ marginLeft: '5px', color: 'var(--bs-info)' }}>
                    <code style={{color: '#eaeaea'}}>
                        {!loading ? playerData.name ?? "Player Not Found" : null}
                    </code>
                </h1>
                {nameHistory.length ?
                    <UncontrolledDropdown direction="down">
                        <DropdownToggle
                            caret
                            className="name-history"
                            tag="a"
                        >
                        </DropdownToggle>
                        <DropdownMenu className="name-history-dropdown dd-name">
                            <DropdownItem header className="name-history-header">Player Name History</DropdownItem>
                            <DropdownItem divider />
                            {nameHistory.map((name, index) => (
                                <DropdownItem text key={index} className="name-history-item">
                                    {name}
                                </DropdownItem>
                            ))}
                        </DropdownMenu>
                    </UncontrolledDropdown>
                : null}
                
            </div>
        </div>
        {contents}
        </>
    );
}